import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=53c94a3b&"
import script from "./Distribution.vue?vue&type=script&lang=ts&"
export * from "./Distribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports